import { createContext, useContext } from "react";

/** Opens the command menu; null outside a signed-in layout. */
export const OpenCommandMenu = createContext<(() => void) | null>(null);

/** The command menu's opener, or null when there is none to open. */
export function useOpenCommandMenu() {
  return useContext(OpenCommandMenu);
}
